import {toURL} from '@homeaway/search-url-parser';

function getParams({
    datedSearchSubmit,
    arrivalDate,
    departureDate,
    filter,
    keywords,
    channel = null,
    tripleId = null,
    adultsCount = 0,
    childrenCount = 0,
    petIncluded = false,
    showGuestPicker = false,
}) {
    const datedParam = datedSearchSubmit
        ? {
              arrivalDate,
              departureDate,
          }
        : {};

    let data = {};
    if (channel && tripleId) {
        data = {
            channel,
            pinnedPropertyListing: tripleId,
        };
    }

    if (filter) {
        data.filter = filter;
    }

    let guestParams = {};

    if (showGuestPicker && adultsCount) {
        guestParams = {
            adultsCount,
            childrenCount,
            petIncluded,
        };
    }

    return {
        q: keywords,
        ...datedParam,
        ...data,
        ...guestParams,
    };
}

export function getSerpUrl(options = {}) {
    const {
        datedSearchSubmit = false,
        refinementKey = null,
        arrivalDate,
        departureDate,
        adultsCount,
        childrenCount,
        petIncluded,
        keywords,
        channel,
        tripleId,
        showGuestPicker,
    } = options;

    const filter = !isNaN(parseInt(refinementKey, 10))
        ? [`filter:${refinementKey}`]
        : '';
    const params = getParams({
        datedSearchSubmit,
        arrivalDate,
        departureDate,
        adultsCount,
        childrenCount,
        petIncluded,
        filter,
        keywords,
        channel,
        tripleId,
        showGuestPicker,
    });

    return toURL(params);
}
